import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";
import { UserCircle, Storefront, Trophy, Gift, Medal, BellSimple, Crown } from "@phosphor-icons/react";
import ProfilePage from "./ProfilePage";
import BookingPagePreview from "../components/BookingPagePreview";
import RewardsPanel from "../components/RewardsPanel";
import ReferralPanel from "../components/ReferralPanel";
import GradePanel from "../components/GradePanel";
import NotificationPrefs from "../components/NotificationPrefs";
import MembershipPanel from "../components/MembershipPanel";

export default function MyProfile({ tab: tabProp, onTabChange }) {
  const { user } = useAuth();
  const [tabState, setTabState] = useState("profile");
  const tab = tabProp ?? tabState;
  const setTab = onTabChange ?? setTabState;
  const role = user.role;

  return (
    <Tabs value={tab} onValueChange={setTab} data-testid="my-profile">
      <TabsList className="bg-[#FAF9F6] mb-6 h-auto w-full justify-start flex-nowrap overflow-x-auto sm:flex-wrap sm:w-auto [&>*]:shrink-0 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
        <TabsTrigger value="profile" data-testid="profile-tab-profile"><UserCircle size={16} className="mr-1" weight="duotone" />Profile</TabsTrigger>
        {(role === "photographer" || role === "dual") && <TabsTrigger value="bookingpage" data-testid="profile-tab-bookingpage"><Storefront size={16} className="mr-1" weight="duotone" />Booking Page</TabsTrigger>}
        {(role === "photographer" || role === "dual") && <TabsTrigger value="grade" data-testid="profile-tab-grade"><Medal size={16} className="mr-1" weight="duotone" />My Grade</TabsTrigger>}
        {role === "agent" && <TabsTrigger value="referral" data-testid="profile-tab-referral"><Gift size={16} className="mr-1" weight="duotone" />Refer &amp; Earn</TabsTrigger>}
        {role === "agent" && <TabsTrigger value="membership" data-testid="profile-tab-membership"><Crown size={16} className="mr-1" weight="duotone" />Membership</TabsTrigger>}
        {role !== "admin" && <TabsTrigger value="rewards" data-testid="profile-tab-rewards"><Trophy size={16} className="mr-1" weight="duotone" />Rewards</TabsTrigger>}
        <TabsTrigger value="notifications" data-testid="profile-tab-notifications"><BellSimple size={16} className="mr-1" weight="duotone" />Notifications</TabsTrigger>
      </TabsList>

      <TabsContent value="profile"><ProfilePage /></TabsContent>
      {(role === "photographer" || role === "dual") && <TabsContent value="bookingpage"><BookingPagePreview onGoProfile={() => setTab("profile")} /></TabsContent>}
      {(role === "photographer" || role === "dual") && <TabsContent value="grade"><GradePanel /></TabsContent>}
      {role === "agent" && <TabsContent value="referral"><ReferralPanel /></TabsContent>}
      {role === "agent" && <TabsContent value="membership"><MembershipPanel /></TabsContent>}
      {role !== "admin" && <TabsContent value="rewards"><RewardsPanel /></TabsContent>}
      <TabsContent value="notifications"><NotificationPrefs /></TabsContent>
    </Tabs>
  );
}
